import { gql, useMutation } from '@apollo/client'
import { SetMyAvatarMutation, SetMyAvatarMutationVariables } from 'types/graphql'

export const getMeQuery = gql`
  query Me {
    me {
      id
      createdAt
      firebaseUid
      avatarFullPath
      firstName
      lastName
      fullName
      email
      phoneNumber
      username
      level
      karmaRequirementForPreviousLevel
      karmaRequirementForNextLevel
      karma
      personal {
        birthday
        hasKids
        hasPets
        pronoun
      }
      bio
      membershipLevel
      membershipExpiresAt
      membershipIsForever
      role
      specialLists
      betaTester
      listCount
      reviewCount
      verificationStatus
      hasCompletedProfile
      hasAddedAdditionalInformation
      abilities
      karma
      level
      firstReviewOfBrandCount
      reviewMediaCount
    }
  }
`

const setAvatarMutation = gql`
  mutation SetMyAvatar($mediaUploadId: Int!) {
    setAvatar(mediaUploadId: $mediaUploadId) {
      id
      avatarFullPath
    }
  }
`

export const useSetAvatar = () => {
  const [setAvatar, { data, loading }] = useMutation<SetMyAvatarMutation, SetMyAvatarMutationVariables>(setAvatarMutation)
  return { setAvatar, data, loading }
}
